import { asApiFailure } from "@utils/apiFailure";

// Copy for a failed certificate upload (E12-S5 / #240, #437). The hook
// suppresses the generic toast, so every outcome the server can return needs
// its own sentence here — above all the 409, which is not "something went
// wrong" but "this location is not eligible". Only approved and pending
// locations are offered, so a 409 means the status changed meanwhile.

const UPLOAD_CERT_NOT_ELIGIBLE_MESSAGE =
    "Only an approved or pending location can take a certificate. This location's status has changed, so nothing was uploaded.";

const UPLOAD_CERT_NOT_FOUND_MESSAGE =
    "This location is no longer available. Close this dialog and try again.";

// Client-side rules run first, so this only shows when the server disagreed
// with them (or the rules drift).
const UPLOAD_CERT_REJECTED_FILE_MESSAGE =
    "The file was rejected. Upload a PDF, JPG, or PNG file that is 10 MB or smaller.";

const UPLOAD_CERT_GENERIC_MESSAGE =
    "Something went wrong while uploading. Please try again.";

export const uploadCertErrorMessage = (error: unknown): string => {
    const failure = asApiFailure(error);

    switch (failure?.status) {
        case 400:
            return UPLOAD_CERT_REJECTED_FILE_MESSAGE;

        case 404:
            return UPLOAD_CERT_NOT_FOUND_MESSAGE;

        case 409:
            return UPLOAD_CERT_NOT_ELIGIBLE_MESSAGE;

        default:
            return UPLOAD_CERT_GENERIC_MESSAGE;
    }
};
